module.exports = require('./src/Optimistic.js');
